const configs = {
  // baseURL:'https://tournament.zjfazhi.com/tournament/api/',
  baseURL:'https://zjvrtournament.zjfazhi.com/tournament/api/',
    evaluationStatus: [
        {
            value: 1,
            label: "已指派任务",
        },
        {
            value: 2,
            label: "空闲",
        },
        {
            value: 3,
            label: "待确认",
        },
    ],
    examStatus: [
        {
            value: 0,
            label: "未开始报名",
        },
        {
            value: 1,
            label: "开始考试",
        },
        {
            value: 2,
            label: "考试结束",
        },
        {
            value: 3,
            label: "开始报名",
        },
    ],
    message:{
        uploadSucc:"上传成功",
        uplaodErr:"上传失败",
        addSucc:"添加成功",
        addErr:"添加失败",
        changeSucc:"修改成功",
        changeErr:"修改失败",
        delSucc:"删除成功",
        delErr:"删除失败",
        uploadImg:"请上传证书",
        selectItem:"请先选择数据",
        buildSucc:"生成考次成功",
        buildErr:"生成考次失败",
        exportSucc:"导入成功",
        exportErr:"导入失败",
        selectItem:'请先选择所需删除信息',
        notStarted:'考试还未开始',
    },
    adminPath:[
        "/bigScreen",
        "/evaluation",
        "/ExaminationPlace",
        "/ExamList",
        "/ExamTime",
        "/Examinee",
        "/Score",
        "/Certificate"
    ],
    sutudentPath:["/student"],
}
export default configs;



// WEBPACK FOOTER //
// ./src/configs/index.js